import React, { useState, useEffect } from "react";
import { Autocomplete } from "@react-google-maps/api";
import "./LandmarkInput.css";

const LandmarkInput = ({
  value,
  onChangeText,
  onPlaceSelected,
  placeholder = "Search for a landmark...",
}) => {
  const [inputValue, setInputValue] = useState(value);
  const [isLoading, setIsLoading] = useState(false);
  const [autocomplete, setAutocomplete] = useState(null);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const onLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
    autocompleteInstance.setComponentRestrictions({ country: "NG" });
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      setIsLoading(true);
      const place = autocomplete.getPlace();

      if (!place.geometry) {
        alert("Please select a valid address from the suggestions.");
        setIsLoading(false);
        return;
      }

      const address = place.formatted_address || place.name || "";
      const coords = {
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
      };

      onPlaceSelected({
        address,
        coords,
        description: place.formatted_address,
        place_id: place.place_id,
        name: place.name,
      });

      setInputValue(address);
      onChangeText(address);
      setIsLoading(false);
    }
  };

  const handleClear = () => {
    setInputValue("");
    onChangeText("");
    onPlaceSelected(null);
  };

  return (
    <div className="landmark-location-container">
      <Autocomplete
        onLoad={onLoad}
        onPlaceChanged={onPlaceChanged}
        options={{
          types: ["address"],
          componentRestrictions: { country: "NG" },
        }}
      >
        <div className="landmark-location-input-wrapper">
          <input
            type="text"
            placeholder={placeholder}
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
              onChangeText(e.target.value);
            }}
            className="landmark-location-input"
            disabled={isLoading}
          />
          {isLoading ? (
            <span className="landmark-location-loading-text">Loading...</span>
          ) : inputValue ? (
            <button
              className="landmark-location-icon landmark-location-clear-button"
              onClick={handleClear}
              type="button"
            >
              ✕
            </button>
          ) : (
            <span className="landmark-location-icon">📍</span>
          )}
        </div>
      </Autocomplete>
    </div>
  );
};

export default LandmarkInput;